<template>
  <Dialog
    variant="modal"
    background="white"
    :side="maxSmall ? 'bottom' : 'default'"
    :icon="!maxSmall ? 'logout' : undefined"
    :title="$t('components.profile.logout.title')"
    :description="$t('components.profile.logout.description')"
    :showCancel="!maxSmall"
    @confirm="$emit('logout')"
  >
    <slot />
  </Dialog>
</template>

<script setup>
import { Dialog } from "@/SharedComponents/Dialog";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["logout"]);
</script>
